"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVersion = exports.stripVersion = exports.hasVersion = void 0;
exports.hasVersion = function (key) {
    return (key || '').includes('@');
};
exports.stripVersion = function (key) {
    key = key || '';
    return key.split('@')[0];
};
exports.getVersion = function (key) {
    return (key || '').split('@')[1] || '';
};
